import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { setAdminSidebar } from "../../../redux/reducers";
import { getAdminSidebar } from "../../../redux/selectors";
import styles from "./index.module.scss";

const Navbar = () => {
  const dispatch: any = useAppDispatch();
  const open: any = useAppSelector((state) => getAdminSidebar(state));

  const handleSidebar = () => {
    dispatch(setAdminSidebar());
  };

  return (
    <div className={styles.navbar}>
      <div className={styles.leftHeader} onClick={handleSidebar}>
        <i
          className={`fa-solid fa-bars ${
            !open
              ? styles.menuHamburger
              : styles.menuHamburger + " " + styles.opened
          }`}
        ></i>
      </div>
      <div className={styles.rightHeader}>
        <ul>
          <li>
            <i className="fas fa-bell"></i>
          </li>
          <li>
            <i className="fas fa-cog"></i>
          </li>
          <li>
            <i className="fas fa-user"></i>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default Navbar;
